// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1a46125e","171":"ef00e54c","453":"68693753","507":"03cccdfa","964":"a6f95b83"}[chunkId] + ".chunk.js";
};